import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b8ce0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-content" }

import { PropType } from 'vue'
import { PPTTableElement } from '@/types/slides'

import StaticTable from './StaticTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTableElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTTableElement>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-table",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(StaticTable, {
          data: __props.elementInfo.data,
          width: __props.elementInfo.width,
          cellMinHeight: __props.elementInfo.cellMinHeight,
          colWidths: __props.elementInfo.colWidths,
          outline: __props.elementInfo.outline,
          theme: __props.elementInfo.theme
        }, null, 8, ["data", "width", "cellMinHeight", "colWidths", "outline", "theme"])
      ])
    ], 4)
  ], 4))
}
}

})